<template>
<div class="k-block" :block="name">
<template v-if="blockMap">
<div class="block-404" v-if="!data">404: {{name}}</div>
<div class="block-imgs" v-else-if="type === 1 || type === 2"><img v-for="item in data" :src="item" :key="item" /></div>
</template>
<div v-else class="txt-loading">数据加载中…</div>
</div>
</template>

<script>
  import {
    mapState,
    mapGetters
  } from 'vuex'
  export default {
    name: 'k-block',
    props: ['name'],
    computed: {
      ...mapState(['blockMap']),
      ...mapGetters(['getBlock', 'getBlockData']),
      block() {
        const {blockMap} = this
        return blockMap ? blockMap[this.name] : null
      },
      type() {
        const {block} = this
        return block ? block.type : 0
      },
      data() {
        return this.getBlockData(this.name)
      }
    }
  }
</script>
